import { type ReactNode } from 'react';

import { nodeHasRenderableContent } from '../../util/elements';

import { ConditionallyRender, type ConditionallyRenderProps } from './ConditionallyRender';

interface IfNodeRendersProps extends Omit<ConditionallyRenderProps, 'show'> {
  readonly node: ReactNode;
}

export const IfNodeRenders = ({ children, node, ...props }: IfNodeRendersProps) => (
  <ConditionallyRender {...props} show={nodeHasRenderableContent(node)}>
    {children}
  </ConditionallyRender>
);
